import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SeoHelmets from '../../SeoOptimazation/SeoHelmets';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import { fetchAllNEETAbouts } from '../../DynamicCourse/api';
import ImageComponent1 from '../../ImageComponent/ImageComponent1';
import Loader from '../../Loader/Loader';
import ButtonPage from '../../ButtonPage/ButtonPage';
import CurrentAffair from '../../CurrentAffair/CurrentAffair';
import Content from '../../AllPageContent/AllPageContent';
import Buttontabs from '../../Buttontabs/Buttontabs';
import NeetCards from './NeetCards';
import Neet_StudyMaterials from './NeetStudyMaterials';
import NeetTestSeriesCards from './NeetTestSeriesCards';

const NeetHomePage = () => {
    const location = useLocation();
    const path = location.pathname;
    const [courses, setCourses] = React.useState([]);
    const [testSeries, setTestSeries] = React.useState([]);
    const [studyMaterials, setStudyMaterials] = React.useState([]);
    const [contentToShow, setContentToShow] = useState('neet');
    const [neetAbouts, setNeetAbouts] = useState([]);
    const [selectedAbout, setSelectedAbout] = useState(null);
    const [loading, setLoading] = useState(false);
    const componentName = "neet";

    useEffect(() => {
        const fetchNeetData = async () => {
            setLoading(true);
            try {
                // Fetch dynamic abouts first
                const aboutsData = await fetchAllNEETAbouts();
                setNeetAbouts(aboutsData || []);
                if (aboutsData && aboutsData.length > 0) {
                    setSelectedAbout(aboutsData[0]);
                }

                // Fetch other data in parallel
                const [coursesRes, testSeriesRes, studyMaterialsRes] = await Promise.all([
                    axios.get(BASE_URL + '/neet/user/courses'),
                    axios.get(BASE_URL + '/neet/user/testseries'),
                    axios.get(BASE_URL + '/neet/user/study-materials')
                ]);
                setCourses(coursesRes.data.data);
                setTestSeries(testSeriesRes.data.data);
                setStudyMaterials(studyMaterialsRes.data.data);
            } catch (error) {
                console.error("Error fetching NEET data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchNeetData();
    }, []);
    return (
        <div>
            <SeoHelmets
                title={
                    path === '/neet/classes' ? "NEET Online Classes & Coaching - Insight IAS" :
                        path === '/neet/study-material' ? "NEET Resources & Notes - Insight IAS" :
                            path === '/neet/testseries' ? "NEET Test Series & Practice Exams - Insight IAS" :
                                selectedAbout?.Title ? `${selectedAbout.Title} | NEET Preparation - Insight IAS` :
                                    "NEET Coaching & Test Series - Medical Preparation"
                }
                description={
                    path === '/neet/classes' ? "Join our expert-led NEET online classes. Comprehensive coaching for Physics, Chemistry, and Biology." :
                        path === '/neet/study-material' ? "Access high-quality NEET resources, notes and study materials for better exam preparation." :
                            path === '/neet/testseries' ? "Practice with our standard NEET test series and improve your score in the medical entrance exam." :
                                selectedAbout?.Title ? `Learn everything about ${selectedAbout.Title} for the NEET exam. Expert guidance and resources from Insight IAS.` :
                                    "Prepare for NEET with Top faculty and study materials. Insight IAS provides specialized coaching and test series for medical aspirants."
                }
                keywords="NEET coaching, medical entrance exam, NEET test series, biology coaching, Insight IAS NEET"
            />
            <div className='Cuet-background'>
                <div className='current-main-box'>
                    <h1>National Eligibility cum Entrance Test (NEET) »»</h1>
                    <Buttontabs componentName='neet' setContentToShow={setContentToShow} />
                </div>
            </div>
            {path === '/neet/classes' && <NeetCards courses={courses} heading="Neet Courses" />}
            {path === '/neet/study-material' && <Neet_StudyMaterials studyMaterials={studyMaterials} heading="Neet Courses" />}
            {path === '/neet/testseries' && <NeetTestSeriesCards testSeries={testSeries} heading="Neet Test Series" />}
            {path === '/neet/about' && (
                <div className='container-fluid cuet-width py-4'>
                    <div className='row'>
                        <div className='col-lg-8 col-md-12 col-sm-12'>
                            {loading ? (
                                <div className='card d-flex align-items-center justify-content-center' style={{ minHeight: '400px', position: 'relative' }}>
                                    <Loader />
                                </div>
                            ) : (
                                <>
                                    {/* All About Sections */}
                                    {neetAbouts.length > 0 ? (
                                        <div className="abouts-container">
                                            {neetAbouts.map((about, index) => (
                                                <div key={about.Sn} className="about-section mb-5">
                                                    <h2 className="fw-bold mb-3" style={{ color: '#dc3545', borderBottom: '2px solid #dc3545', display: 'inline-block', paddingBottom: '5px' }}>
                                                        {about.Title}
                                                    </h2>
                                                    <Content paragraphs={about?.Description || []} />
                                                    <hr className="my-4" style={{ opacity: 0.1 }} />
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className='card d-flex align-items-center justify-content-center' style={{ minHeight: '400px', position: 'relative' }}>
                                            <p>No Information Available</p>
                                        </div>
                                    )}
                                    <ButtonPage Pagename="EnquiryOnly" noteurl="" />
                                </>
                            )}
                        </div>
                        <div className='col-lg-4 card px-0 col-md-12 col-sm-12'>
                            <CurrentAffair componentName={componentName} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default NeetHomePage

{/* <p
                className="text-dark"
                style={{
                    fontFamily: "'Rubik', sans-serif",
                    fontSize: '0.95rem',
                    lineHeight: '1.5',
                    letterSpacing: '1.2px',
                    color: '#a54a06',
                    margin: '0.25rem 0',
                    padding: '0.5rem 0.75rem',
                    backgroundColor: '#fff8f2',
                    borderLeft: '4px solid #a54a06',
                    borderRadius: '0.25rem',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                }}
            >
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Illum quam modi fugit
                ipsam cumque cum, facilis nisi. Voluptatibus eos laudantium enim iste libero
                eius minima ullam quod harum.
            </p> */}